var render, staticRenderFns
import script from "./CardRailContainer.vue?vue&type=script&lang=tsx"
export * from "./CardRailContainer.vue?vue&type=script&lang=tsx"
import style0 from "./CardRailContainer.vue?vue&type=style&index=0&id=133739f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133739f7",
  null
  
)

export default component.exports